<template>
  <div class="app-header">
    <search-sidebar ref="search"/>
    <div class="d-block d-md-none">
      <i class="cursor-pointer" :class="sidebarActive?'ti-close':'ti-menu'" style="font-size: 20px"
         @click="()=> $root.$emit('toggleSidebar')"></i>
      <router-link class="navbar-brand ml-3" :to="{name: 'home'}">
        <img height="40" :src="logo_mini" alt="">
      </router-link>
    </div>
    <i class="ti-search cursor-pointer d-block d-md-none mr-3" style="font-size: 20px"
       @click="$refs.search.toggle()"></i>
    <router-link class="navbar-brand d-md-block d-none" :to="{name: 'home'}">
      <img height="40" :src="logo" alt="">
    </router-link>
    <div class="nav-item searchBar flex-grow-1 mx-lg-5 d-md-block d-none" style="max-width: 600px">
      <vue-autosuggest class="autosuggest" v-model="query" :suggestions="filteredOptions" @selected="onSelected"
                       :limit="10"
                       :get-suggestion-value="getSuggestionValue"
                       :input-props="inputProps">
        <template slot-scope="{suggestion}">
          <div>
                    <span v-if="suggestion.name === 'subject' || suggestion.name === 'chapter'">{{
                        suggestion.item.name
                      }}</span>
            <span v-else>{{ suggestion.item.title }}</span>
          </div>
        </template>
      </vue-autosuggest>
      <i class="prepend ti-search"></i>
      <i @click="reset" class="ti-close append cursor-pointer"></i>
    </div>
    <b-dropdown class="dropdown-menu-right user-info d-md-block d-none" right variant="empty"
                menu-class="user-account-settings"
                no-caret>
      <template slot="button-content">
        <img :src="user.avatar" class="avatar ml-1" alt="">
        <div>
          <div class="user_name">{{ user.full_name }}</div>
          <span class="classroom_name">{{ classroom.name }}</span>
        </div>
        <i class="ti-angle-down text-green"></i>
      </template>
      <b-dropdown-item active-class="" :href="home_url">
        <i class="ti-home"></i>
        <span>Acceuil</span>
      </b-dropdown-item>
      <b-dropdown-item active-class="" :to="{name:'home'}">
        <i class="ti-layout-grid4"></i>
        <span>Tableau de bord</span>
      </b-dropdown-item>
      <b-dropdown-item active-class="" :to="{name:'subscriptions'}">
        <i class="ti-package"></i>
        <span>Mes abonnements</span>
      </b-dropdown-item>
      <b-dropdown-item active-class="" :to="{name:'payments'}">
        <i class="ti-money"></i>
        <span>Mes Factures</span>
      </b-dropdown-item>
      <b-dropdown-item active-class="" :to="{name:'profile'}">
        <i class="ti-user"></i>
        <span>Profil</span>
      </b-dropdown-item>
      <b-dropdown-item active-class="" @click="logout">
        <i class="ti-close"></i>
        <span>Se déconnecter</span>
      </b-dropdown-item>
    </b-dropdown>
  </div>

</template>

<script>
import {mapGetters} from 'vuex'
import SearchMixin from "@/components/Mixins/SearchMixin";
import SearchSidebar from "@/components/SearchSidebar";

export default {
  name: 'Header',
  props: {
    sidebarActive: {type: Boolean}
  },
  components: {SearchSidebar},
  mixins: [SearchMixin],
  data() {
    return {
      searchActive: false
    }
  },
  computed: {
    ...mapGetters(['user', 'classroom', 'home_url', 'logo', 'logo_mini']),
  },
  methods: {
    logout() {
      window.logout()
    }
  },
  mounted() {
  }
}
</script>
<style lang="scss">
.user-info {
  button {
    display: flex;
    @include gap-items-x(2px);
    text-align: left;
    align-items: center;

    .user_name, .classroom_name {
      max-width: 100px;
      @include no-break();
    }

    .classroom_name {
      font-size: 13px;
      color: $green;
    }

    .user_name {
      font-size: 16px;
      font-weight: 500;
      line-height: 16px;
    }
  }

  .dropdown-menu {
    li {
      .dropdown-item {
        i {
          margin-right: 15px;
        }

        &.router-link-exact-active {
          background-color: $green;
          color: white;
        }
      }

      &:not(:last-child) .dropdown-item {
        border-bottom: 1px solid $gray;
      }
    }
  }
}

.autosuggest {
  width: 100%;

  .autosuggest__results-container {
    z-index: 1;
    position: absolute;
    width: 100%;
    background: white;
    margin-top: 5px;

    .autosuggest__results {
      overflow: auto;
      border: 1px solid #ccc;
      max-height: 50vh;
      border-radius: 5px;
    }

    .autosuggest__results-before {
      padding: 10px 15px 5px 15px;
      color: $green;
      font-weight: 600;
      font-size: 16px;
    }

    .autosuggest__results-item {
      padding: 7px 15px;
      cursor: pointer;

      &:hover, &.autosuggest__results-item--highlighted {
        background-color: $gray;
      }
    }
  }
}

.app-header {
  z-index: 10;
  justify-content: space-between;
  height: 60px;
  background-color: white;
  display: flex !important;
  align-items: center;
  padding: 5px 15px;

  .searchBar {
    position: relative;

    input {
      outline: none;
      border: none;
      border-radius: 10px;
      height: 35px;
      width: 100%;
      padding: 20px 40px !important;
      transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;
      box-shadow: 0 1px 0 rgba(17, 17, 17, 0.1);

      &::placeholder {
        color: #6c757d;
        opacity: 0.6;
      }

      &:focus {
        box-shadow: 0 0 0 .2rem rgba(0, 123, 255, .25);
        border-color: #80bdff;
      }
    }

    .prepend, .append {
      font-weight: 800;
      position: absolute;
      top: 10px;
      font-size: 20px;
    }

    .prepend {
      left: 10px;
    }

    .append {
      right: 10px;
    }
  }
}
</style>
